import { render } from "./SavedWorkspace.vue?vue&type=template&id=6f63eae5&scoped=true&ts=true"
import script from "./SavedWorkspace.vue?vue&type=script&lang=ts"
export * from "./SavedWorkspace.vue?vue&type=script&lang=ts"

import "./SavedWorkspace.vue?vue&type=style&index=0&id=6f63eae5&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f63eae5"]])

export default __exports__